/** Normalize phone to international digits-only (e.g. 905xxxxxxxxx for TR mobile). */
export function normalizePhoneToInternationalDigits(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  const trimmed = raw.trim();
  const hasPlus = trimmed.startsWith('+');
  let digits = trimmed.replace(/\D/g, '');
  if (digits.length < 10) return null;

  if (hasPlus || digits.startsWith('90')) {
    if (digits.startsWith('90') && digits.length >= 12) return digits;
    if (hasPlus && digits.length >= 11) return digits;
  }

  if (digits.length === 11 && digits.startsWith('0')) digits = `90${digits.slice(1)}`;
  else if (digits.length === 10 && digits.startsWith('5')) digits = `90${digits}`;

  if (digits.startsWith('90') && digits.length === 12) return digits;
  if (digits.length >= 10 && digits.length <= 15) return digits;
  return null;
}

export function formatPhoneForDisplay(raw: string | null | undefined): string | null {
  const digits = normalizePhoneToInternationalDigits(raw);
  if (!digits) return null;
  if (digits.startsWith('90') && digits.length === 12) {
    const local = digits.slice(2);
    return `+90 ${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6, 8)} ${local.slice(8)}`;
  }
  return `+${digits}`;
}
